// Page standalone : pas d'AppLayout, page focalisée (comme login)
export default [];
